export class OpenAddBrickDialogAction {
   public static readonly type = '[AddBrickDialog] Open Brick menu';
}

export class CloseAddBrickDialogAction {
   public static readonly type = '[AddBrickDialog] Close Brick menu';
}

export class ToggleAddBrickDialog {
   public static readonly type = '[AddBrickDialog] Toggle Brick menu';
}

export class BrickCategoryTabSelectedAction {
   public static readonly type = '[AddBrickDialog] Brick Category Tab selected';

   constructor(public tabIndex: number) {}
}

export class BrickDescriptionSearchChangedAction {
   public static readonly type = '[AddBrickDialog] Search text changed';

   constructor(public searchText: string) {}
}

export class BrickDescriptionSelectedForDetailsAction {
   public static readonly type = '[AddBrickDialog] BrickDescription selected for details';

   constructor(public brickDefinitionId: string) {}
}
